import path from 'path'

const DJANGO_URL = window.location.pathname.split('/').slice(0, 3).join('/')

export let routePaths = {
  root: DJANGO_URL,
  basePanel: path.join(DJANGO_URL, 'base_panel'),
  signup: path.join(DJANGO_URL, 'signup'),
  success: path.join(DJANGO_URL, 'success'),
}

export let linkPaths = {
  signup: path.join(DJANGO_URL, 'signup'),
  success: path.join(DJANGO_URL, 'success'),
}
